import { PKR_INITIAL_ERROR, PKR_INITIAL_LOCAL_STORAGE, PKR_LOADERS } from '@swf/poker';

import type { PageData } from '../types/common';

type Props = Partial<PageData> & Partial<PageData['games']>;

export const clubId = 1006902;

const mockState = ({
  announcement = null,
  clubs = [],
  loading = {
    [PKR_LOADERS.initial]: false
  },
  recentTourns = [],
  registeredTourns = [],
  selectedGameIds = [],
  tables = [],
  tourns = [],
  playersByClubId = {},
  playerTournamentResults = [],
  clubSeasonsById = {},
  clubSeasonStatsById = {},
  clubOptionsById = {},
  clubMembers = {
    approved: [],
    pending: [],
    blocked: []
  },
  clubRecentTournamentSummary = [],
  error = PKR_INITIAL_ERROR,
  uiLayout = { clubNavHidden: false, standingsPlayMoneyFlag: false },
  localStorage = PKR_INITIAL_LOCAL_STORAGE,
  wallPosts = [],
  wallRanks = [],
  serviceStatusData = []
}: Props): PageData => ({
  announcement,
  clubs,
  clubMembers,
  clubSeasonsById,
  clubSeasonStatsById,
  clubRecentTournamentSummary,
  games: {
    recentTourns,
    registeredTourns,
    selectedGameIds,
    tables,
    tourns
  },
  error,
  uiLayout,
  playerTournamentResults,
  serviceStatusData,
  loading,
  playersByClubId,
  clubOptionsById,
  localStorage,
  tableStructures: { tableParams: [] },
  wallPosts,
  wallRanks
});

export default mockState;
